import { render, staticRenderFns } from "./localities.vue?vue&type=template&id=c6679a16"
import script from "./localities.vue?vue&type=script&lang=js"
export * from "./localities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports